import {
  shouldShowRotateHint,
  recordRotateHintShown,
  recordRotateHintDismissed,
  recordRotateHintUsed,
} from '../utils/rotate_hint_storage'
import {orientationChangeSupported} from '../utils/orientation_utils'

export const ActionTypes = {
  SHOW_TOAST: 'leaderboardV2/SHOW_TOAST',
  HIDE_TOAST: 'leaderboardV2/HIDE_TOAST',
}

// Toast kinds. The component owns the copy and the icon for each one, the
// store only remembers which is on screen.
export const TOAST_LINK_COPIED = 'link_copied'
export const TOAST_LINK_COPY_FAILED = 'link_copy_failed'
export const TOAST_ROTATE_HINT = 'rotate_hint'

// Each dispatch gets a fresh nonce, so showing the kind already on screen
// still counts as a new toast: the auto-hide timer restarts and the live
// region content remounts (re-announcing it to screen readers).
let toastNonce = 0

export const showToast = (kind) => ({
  type: ActionTypes.SHOW_TOAST,
  payload: {kind, nonce: ++toastNonce},
})

export const hideToast = () => ({type: ActionTypes.HIDE_TOAST})

// Landing-time coach mark: no tap needed, and it never reappears once the
// per-browser budget in rotate_hint_storage runs out.
//
// Only where rotating from the page is impossible — the same test that hides
// the rotate button. Where the button works it is the guidance, and a hint
// telling the user to do by hand what the button does for them is just noise.
export const maybeShowRotateHint = () => (dispatch) => {
  if (orientationChangeSupported() || !shouldShowRotateHint()) {
    return
  }

  recordRotateHintShown()
  dispatch(showToast(TOAST_ROTATE_HINT))
}

export const dismissRotateHint = () => (dispatch) => {
  recordRotateHintDismissed()
  dispatch(hideToast())
}

// The user reached landscape (or tapped the rotate button): retire the hint
// and clear it if it is still on screen.
export const markRotateHintUsed = () => (dispatch, getState) => {
  recordRotateHintUsed()

  if (getState().toast.kind === TOAST_ROTATE_HINT) {
    dispatch(hideToast())
  }
}
